import { markCatalogMediaCover } from "../../../utils/catalogMediaCover";
import { clearCatalogColorCover, markCatalogColorCover, mediaCanCoverColor } from "../../../utils/catalogColorCover";
import { moveListItem } from "../../../utils/catalogProductStudioShared";

/** Media mutations on the drafts. Covers follow the existing, API-mirrored rules. */
export const mediaDraftActions = {
  setProductCover: (items, index) => markCatalogMediaCover(items, index),
  toggleColorCover: (items, index, colorOptionValueId, shouldSet) =>
    shouldSet
      ? markCatalogColorCover(items, index, colorOptionValueId)
      : clearCatalogColorCover(items, colorOptionValueId),
  move: (items, index, direction) => moveListItem(items, index, direction),
  remove: (items, index) => {
    const next = items.filter((_item, itemIndex) => itemIndex !== index);
    if (next.length && !next.some((item) => item.isCover)) {
      next[0] = { ...next[0], isCover: true };
    }
    return next;
  },
  update: (items, index, field, value) =>
    items.map((item, itemIndex) => (itemIndex === index ? { ...item, [field]: value } : item)),
  /** Changing variant links drops colour covers the image no longer qualifies for. */
  setVariantIds: (items, index, variantIds, colors) =>
    items.map((item, itemIndex) => {
      if (itemIndex !== index) return item;
      const next = { ...item, variantIds };
      const colorById = new Map(colors.map((color) => [color.optionValueId, color]));
      next.colorCoverOptionValueIds = (item.colorCoverOptionValueIds || []).filter((valueId) =>
        mediaCanCoverColor(next, colorById.get(valueId))
      );
      return next;
    }),
};
